var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgMedic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    style: {
      fill: "rgb(233,244,246)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.929968,0,0,0.929968,0.420192,0.420192)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 4.242,
    style: {
      fill: "rgb(75,224,26)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.965926,0.258819,-0.258819,0.965926,1.67459,-1.03958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.383,3.207C5.214,3.207 5.075,3.346 5.075,3.516L5.075,4.753L3.841,4.753C3.672,4.753 3.533,4.892 3.533,5.062L3.533,6.299C3.533,6.468 3.672,6.608 3.841,6.608L5.075,6.608L5.075,7.845C5.075,8.014 5.214,8.154 5.383,8.154L6.617,8.154C6.786,8.154 6.925,8.014 6.925,7.845L6.925,6.608L8.159,6.608C8.328,6.608 8.467,6.468 8.467,6.299L8.467,5.062C8.467,4.892 8.328,4.753 8.159,4.753L6.925,4.753L6.925,3.516C6.925,3.346 6.786,3.207 6.617,3.207L5.383,3.207Z",
    style: {
      fill: "rgb(229,244,247)",
      fillRule: "nonzero"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgMedic);
export default __webpack_public_path__ + "static/media/bg-medic.b79ccb6d041012a7c0f907e875ad8c62.svg";
export { ForwardRef as ReactComponent };